import { useMemo } from 'react';

const confidenceTable = [
  {
    value: 99,
    minHumanReviews: 12,
  },
  {
    value: 95,
    minHumanReviews: 11,
  },
  {
    value: 90,
    minHumanReviews: 9,
  },
  {
    value: 80,
    minSimulations: 21,
    minHumanReviews: 7,
  },
  {
    value: 70,
    minSimulations: 11,
    minHumanReviews: 5,
  },
  {
    value: 60,
    minSimulations: 9,
    minHumanReviews: 3,
  },
  {
    value: 50,
    minSimulations: 7,
    minHumanReviews: 2,
  },
  {
    value: 40,
    minSimulations: 4,
    minHumanReviews: 1,
  },
  {
    value: 30,
    minSimulations: 1,
  },
];

export const useConfidence = (
  failedSimulationsCount: number,
  succededSimulationsCount: number,
  failedHumanReviewsCount: number,
  succededHumanReviewsCount: number
) => {
  const calculateConfidence = (
    failedSimulations: number,
    succededSimulations: number,
    failedHumanReviews: number,
    succededHumanReviews: number
  ): number => {
    const threshold = confidenceTable.find((level) => {
      if (
        !!level.minHumanReviews &&
        succededHumanReviews >= level.minHumanReviews
      )
        return true;
      if (!!level.minSimulations && succededSimulations >= level.minSimulations)
        return true;

      return false;
    });

    if (!threshold) return 0;

    const simulationPenaltyWeight = 0.1;
    const humanReviewPenaltyWeight = 1;

    const simulationPenalty =
      failedSimulations > 0
        ? (failedSimulations / (failedSimulations + succededSimulations)) *
          100 *
          simulationPenaltyWeight
        : 0;
    const humanReviewPenalty =
      failedHumanReviews > 0
        ? (failedHumanReviews / (failedHumanReviews + succededHumanReviews)) *
          100 *
          humanReviewPenaltyWeight
        : 0;

    const calculated = Math.round(
      threshold.value - simulationPenalty - humanReviewPenalty
    );

    return calculated > 0 ? calculated : 0;
  };

  const confidence = useMemo(
    () =>
      calculateConfidence(
        failedSimulationsCount,
        succededSimulationsCount,
        failedHumanReviewsCount,
        succededHumanReviewsCount
      ),
    [
      failedSimulationsCount,
      succededSimulationsCount,
      failedHumanReviewsCount,
      succededHumanReviewsCount,
    ]
  );

  return confidence;
};
